import { i18nKeys } from 'translationTypes'
import i18n from '../../../i18n'

export default {
  title: () => i18n.t(i18nKeys.anfd__setFirstDash__title),
  pageHeading: () => i18n.t(i18nKeys.anfd__page__heading),
  getStarted: () => i18n.t(i18nKeys.common__getStarted),
  error: {
    notBusy: () => i18n.t(i18nKeys.anfd__error__notBusy),
  },
  splash: {
    content1: () => i18n.t(i18nKeys.anfd__splash__content_1),
    content2: () => i18n.t(i18nKeys.anfd__splash__content_2),
    content3: () => i18n.t(i18nKeys.anfd__splash__content_3),
    primary: () => i18n.t(i18nKeys.anfd__cta__primary),
    secondary: () => i18n.t(i18nKeys.anfd__cta__secondary),
    welcome: name => `${i18n.t(i18nKeys.common__welcome)}, ${name}!`,
  },
  start: {
    title: () => i18n.t(i18nKeys.anfd__page__start__title),
    content1: () => i18n.t(i18nKeys.anfd__page__start__content_1),
    content2: () => i18n.t(i18nKeys.anfd__page__start__content_2),
    content3: () => i18n.t(i18nKeys.anfd__page__start__content_3),
  },
  heatmap: {
    title: () => i18n.t(i18nKeys.anfd__page__heatMap__title),
    content1: () => i18n.t(i18nKeys.anfd__page__heatMap__content_1),
    content2: () => i18n.t(i18nKeys.anfd__page__heatMap__content_2),
  },
  order: {
    title: () => i18n.t(i18nKeys.anfd__page__order__title),
    content1: () => i18n.t(i18nKeys.anfd__page__order__content_1),
    content2: () => i18n.t(i18nKeys.anfd__page__order__content_2),
    content3: () => i18n.t(i18nKeys.anfd__page__order__content_3),
  },
  support: {
    title: () => i18n.t(i18nKeys.anfd__page__support__title),
    content1: () => i18n.t(i18nKeys.anfd__page__support__content_1),
    content2: () => i18n.t(i18nKeys.anfd__page__support__content_2),
    content3: () => i18n.t(i18nKeys.anfd__page__support__content_3),
  },
}
